import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-verdmat',
  templateUrl: './about-verdmat.component.html',
  styleUrls: ['./about-verdmat.component.scss']
})
export class AboutVerdmatComponent implements OnInit {

  environment = environment;

  constructor() { }

  ngOnInit(): void {
  }
}
